import * as actionTypes from 'Constants/redux';

export function setOperationsFilter(filter) {
  return (dispatch) =>
    dispatch({
      type: actionTypes.SET_OPERATIONS_FILTER,
      payload: { filter },
    });
}
